const $$splitComponentImporter = () => import('/Users/vthang/projects/marvy/marvy_mono/apps/pinktool/src/routes/_app/boards.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_app/boards")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});